import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import styles from "./styles.less"
import BaseCheckbox from "@cirrus/legacy/app-components/form-controls/checkboxes/checkbox/index.jsx"
import withSkinV2 from "@cirrus/legacy/app-common/alt/framework/withSkinV2.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"

class Checkbox extends Component {
  static propTypes = {
    label: PropTypes.string,
    badge: PropTypes.number,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    showTooltip: PropTypes.bool,
  }

  render() {
    const {
      label,
      showTooltip,
      checked,
      onChange,
      badge,
      dynamicStyles: { classes },
    } = this.props

    return (
      <div className={styles.item}>
        <BaseCheckbox
          className={styles.checkbox}
          label={label}
          showTooltip={showTooltip}
          checked={checked}
          onChange={onChange}
        />
        <div className={classNames(styles.badge, classes.checkboxBadge)}>{badge}</div>
      </div>
    )
  }
}

const defaultSkinObject = {
  checkboxBadge: {
    backgroundColor: v.orange420,
    borderRadius: "50%",
    color: "",
  },
}

export default withSkinV2({
  skinObjectSelector: (skinObject) => skinObject.sidebar || {},
  defaultSkinObject,
})(Checkbox)
